<table id="excel-table" width="100%">
    <tr>
        <td>
            <h5>{{ReportName}}</h5>
        </td>
        <td style="text-align: center;">
            <h4>{{OrganizationName}}</h4>
        </td>
        <td style="text-align: right;">
            <h5>{{ dateFrom | date: 'MM/dd/yyyy'}} - {{ dateTo | date:'MM/dd/yyyy'}} </h5>
        </td>
    </tr>
</table>

<p-table *ngIf="false" [columns]="cols" [value]="products" [loading]="loading" [scrollable]="true"
    [style]="{width:'100%'}" [rows]="showRows"
    [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [paginator]="true" selectionMode="single"
    [ngStyle]="{'display':IsShowReportTemplate=== true ? 'block' : 'none' }"
    [(first)]="first" styleClass="p-datatable-gridlines" [resizableColumns]="true">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <ng-container *ngFor="let col of columns; let i = index;">
                <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    {{col.header}}
                </th>
            </ng-container>

        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
            <ng-container *ngFor="let col of columns; let i = index;">
                <td>
                    <div *ngIf="col.dataType=='datetime'; else nonboldContent">
                        {{rowData[col.field] | localDate }}
                    </div>

                    <ng-template #nonboldContent>
                        <div [style]="i==(columns.length-1) ?'inline-size: 250px;overflow-wrap: break-word;': ''">{{rowData[col.field]}}</div>
                    </ng-template>

                </td>
            </ng-container>

        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="18">{{noContactFindOrLoadingText}}</td>
        </tr>
    </ng-template>
</p-table>

<p-table *ngIf="true" #loginReportsTabel [columns]="cols" [value]="products" [loading]="loading" [scrollable]="true"
    [style]="{width:'100%'}" [(rows)]="showRows"
    [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [paginator]="true" selectionMode="single"
    [ngStyle]="{'display':IsShowReportTemplate=== true ? 'block' : 'none' }"
    [(first)]="first" styleClass="p-datatable-gridlines" [resizableColumns]="true">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <ng-container *ngFor="let col of columns; let i = index;">
                <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    {{col.header}}
                </th>
            </ng-container>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-index="rowIndex" let-rowData let-columns="columns">
        <tr *ngIf="index>0 ? (products[index-1].userName!=rowData.userName || index%loginReportsTabel.rows==0): true" class="parentRow">
            <td [colspan]="columns.length">{{rowData.userName}}</td>
        </tr>
        <tr>
            <ng-container *ngFor="let col of columns; let i = index;">
                <td>

                    <ng-container  [ngSwitch]="col.dataType">
                        <ng-container *ngSwitchCase="'datetime'">
                            {{ rowData[col.field] | localDate }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'secsdhms'">
                            {{ rowData[col.field] | secsToDhms }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <div [style]="i==(columns.length-1) ?'inline-size: 250px;overflow-wrap: break-word;': ''">{{rowData[col.field]}}</div>
                        </ng-container>
                    </ng-container>

                </td>
            </ng-container>

        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="18">{{noContactFindOrLoadingText}}</td>
        </tr>
    </ng-template>
</p-table>
